module.exports = "mutation resetUserPassword($id: ID = null) {\n  resetUserPassword(input: {id: $id}) {\n    user {\n      id\n      email\n    }\n  }\n}\n"